const enum TechnologySignalSubType {
    AddedTechnologies = "AddedTechnologies",
    AddedIntegrations = "AddedIntegrations",
    RemovedTechnologies = "RemovedTechnologies",
    RemovedIntegrations = "RemovedIntegrations",
    RemovedMyTechnologies = "RemovedMyTechnologies",
    CompetitorRenewalComingUp = "CompetitorRenewalComingUp",
}

export default TechnologySignalSubType;
